// extracted by mini-css-extract-plugin
module.exports = {"select":"product-sorting_select__KQzwf","input":"product-sorting_input__C_ZGm","icon":"product-sorting_icon__EMzlj"};